// Round half up to the nearest whole rupee for DISPLAY only:
//   fractional part < 0.5  -> floor  (e.g. 100.49 -> 100)
//   fractional part >= 0.5 -> ceil   (e.g. 100.50 -> 101)
// Returns the original value untouched when it isn't a finite number (null/'' etc.),
// so empty cells stay empty rather than becoming 0.
export const roundAmount = (value) => {
  if (value === null || value === undefined || value === '') return value;
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  const floor = Math.floor(num);
  return num - floor < 0.5 ? floor : Math.ceil(num);
};

export default roundAmount;
